<template>
  <v-card class="show candidate" v-if="candidate">
    <v-card-title primary-title>
      <div v-if="candidate.profile">
        <div class="headline">{{ candidate.profile.fullName }}</div>
        <span class="grey--text">{{ candidate.email }}</span>
      </div>
      <div v-else class="grey--text">{{ candidate.email }}</div>
    </v-card-title>

    <EmailConfirmationBanner :candidate="candidate" @refresh="$emit('refresh')" />
    <SuspendedOrBlockedBanner :candidate="candidate" @refresh="$emit('refresh')" />

    <v-card-text class="px-0">
      <v-divider />
      <table class="v-table theme--dark">
        <tbody>
          <tr>
            <th class="text-xs-right">ID</th>
            <td>{{ candidate.id }}</td>
          </tr>
          <tr>
            <th class="text-xs-right">Profile</th>
            <td>
              <router-link v-if="candidate.profile" :to="`/profiles/${candidate.profile.id}`">
                {{ candidate.profile.fullName }}
              </router-link>
              <em v-else>Not present</em>
            </td>
          </tr>
          <tr>
            <th class="text-xs-right">Current Email</th>
            <td>
              {{ candidate.email }}
            </td>
          </tr>
          <tr>
            <th class="text-xs-right">Authentications</th>
            <td>
              <v-chip
                v-for="auth in candidate.authentications"
                :key="`candidate-${auth.provider}`"
                avatar
              >
                <v-avatar>
                  <v-icon>mdi-{{ auth.provider }}</v-icon>
                </v-avatar>
                {{ auth.email }}
              </v-chip>
            </td>
          </tr>
          <tr>
            <th class="text-xs-right">Campaign</th>
            <td v-if="candidate.campaign">
              <router-link :to="`/campaigns/${candidate.campaign.id}`">
                {{ `${candidate.campaign.slug}` }}
              </router-link>
              (<span>{{ candidate.campaign.organization.name }}</span>
              <span v-if="candidate.campaign.opportunity">– {{ candidate.campaign.opportunity.name }}</span>)
            </td>
            <td v-else>
              <em>Not present</em>
            </td>
          </tr>
          <tr>
            <th class="text-xs-right">Created</th>
            <td>
              {{ new Date(candidate.createdAt) | date('h:mm a, MMMM do yyyy') }}
              ({{ new Date(candidate.createdAt) | inWords({ addSuffix: true }) }})
            </td>
          </tr>
          <tr>
            <th class="text-xs-right">Last updated</th>
            <td>
              {{ new Date(candidate.updatedAt) | date('h:mm a, MMMM do yyyy') }}
              ({{ new Date(candidate.updatedAt) | inWords({ addSuffix: true }) }})
            </td>
          </tr>
        </tbody>
      </table>
      <v-divider />
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <can I="delete" a="Candidate">
        <v-dialog v-model="dialog" lazy absolute max-width="500px">
          <v-btn flat color="error" slot="activator"> <v-icon left>mdi-delete</v-icon> Delete </v-btn>
          <v-card>
            <v-card-title>
              <div class="headline">Are you sure?</div>
            </v-card-title>
            <v-card-text>
              This action will permanently delete a candidate and their linked profile.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn flat @click="dialog = false" color="grey">
                cancel
              </v-btn>
              <v-btn @click="destroy" color="error">
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>

      <can I="edit" a="Candidate">
        <v-btn @click="$emit('edit')" color="primary"> <v-icon left>mdi-pencil</v-icon> Edit </v-btn>
      </can>
    </v-card-actions>
  </v-card>
</template>

<script>
// Components
import EmailConfirmationBanner from '@/components/candidates/EmailConfirmationBanner'
import SuspendedOrBlockedBanner from '@/components/candidates/SuspendedOrBlockedBanner'

// Vue Component
export default {
  components: { EmailConfirmationBanner, SuspendedOrBlockedBanner },
  data() {
    return { dialog: false }
  },
  computed: {
    candidate() {
      return this.$store.getters['admin/candidates/find'](this.$route.params.id)
    },
  },
  methods: {
    destroy() {
      this.$emit('destroy')
    },
  },
}
</script>
